import { render, staticRenderFns } from "./mappings.vue?vue&type=template&id=0e7a923e&"
import script from "./mappings.vue?vue&type=script&lang=js&"
export * from "./mappings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports